export const Timer = function Timer({ opts } = { opts: {} }) {
  const delay = opts.delay || opts.delay === 0 ? opts.delay : null;
  const task = opts.task;
  let timerEvent;
  let startTime = null;
  let taskCalledTimes = 0;

  // eslint-disable-next-line
  function start() {
    if ((delay || delay === 0) && task) {
      startTime = Date.now();
      timerEvent = setTimeout(() => {
        task();
        taskCalledTimes += 1;
        startTime = null;
      }, delay);
    }
  }

  // eslint-disable-next-line
  function timerTaskCalled() {
    return { taskCalled: taskCalledTimes > 0, timesCalled: taskCalledTimes };
  }

  // eslint-disable-next-line
  function resume() {
    if (startTime && !timerEvent && taskCalledTimes === 0) {
      const resumeDiff = Date.now() - startTime;
      if (resumeDiff < delay) {
        timerEvent = setTimeout(() => {
          task();
          taskCalledTimes += 1;
        }, delay - resumeDiff);
      } else {
        task();
        taskCalledTimes += 1;
      }
      startTime = null;
    }
  }

  // eslint-disable-next-line
  function pause() {
    if (timerEvent) {
      clearTimeout(timerEvent);
      timerEvent = null;
    }
  }

  // eslint-disable-next-line
  function stop() {
    if (timerEvent) {
      clearTimeout(timerEvent);
      timerEvent = null;
    }
    startTime = null;
  }

  return {
    start,
    pause,
    stop,
    resume,
    timerTaskCalled,
  };
};
